<template>
  <div class="container">
    <vs-breadcrumb :items="[
        { title: 'Seguridad', url: '/security' },
        { title: 'Rutas Backoffice', active: true },
    ]"></vs-breadcrumb>
    <vx-card title="Lista de rutas del backoffice">
      <slot name="head">
        <vs-button
            @click="showCreatePopup = true"
            size="small"
        >
          Crear nueva ruta
        </vs-button>
      </slot>
      <slot name="content">
        <vs-table
          stripe
          pagination
          :max-items="50"
          search
          noDataText="No hay datos disponibles"
          :data="routes">
          <template slot="thead">
            <vs-th>Id</vs-th>
            <vs-th>Path</vs-th>
            <vs-th>Permissions</vs-th>
            <vs-th>Opciones</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr v-for="(route, i) in data" :key="i">
              <vs-td>{{route.id}}</vs-td>
              <vs-td>{{route.path}}</vs-td>
              <vs-td>{{route.permissions.join(", ")}}</vs-td>
              <vs-td style="width: 12vw">
                <vs-button
                  @click="showEditPopupHandler(route)"
                  type="border"
                  size="small"
                >
                  Editar
                </vs-button>
                <vs-button
                  class="ml-2"
                  type="border"
                  color="danger"
                  size="small"
                  @click="confirmDeletion(route, i)"
                >
                  Eliminar
                </vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </slot>
    </vx-card>


    <vs-popup :active.sync="showEditPopup" title="Editar ruta Backoffice">
      <div v-if="routeSelected !== null">
        <vs-input label="Ruta" v-model="routeSelected.path"></vs-input>

        <div class="mt-4">
          <label>Permisos</label>
          <v-select
            v-model="routeSelected.permissions"
            multiple
            label="name"
            :reduce="role => role.guard_name"
            :options="roles"></v-select>
        </div>
      </div>

      <div class="p-5 h-24"></div>

      <vs-button @click="saveChangesHandler">
        Guardar cambios
      </vs-button>
    </vs-popup>

    <vs-popup :active.sync="showCreatePopup" title="Crear nueva ruta">
      <vs-input label="Ruta" v-model="createRouteForm.path"></vs-input>

      <div class="mt-4">
        <label>Permisos</label>
        <v-select
            v-model="createRouteForm.permissions"
            multiple
            label="name"
            :reduce="role => role.guard_name"
            :options="roles"></v-select>
      </div>

      <div class="p-5 h-24"></div>

      <vs-button @click="createRouteHandler">
        Crear ruta
      </vs-button>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: "RouteList",
  data: () => ({
    routes: [],
    routeSelected: null,
    showEditPopup: false,
    showCreatePopup: false,
    roles: [],
    createRouteForm: {
      path: null,
      permissions: []
    }
  }),
  async mounted() {
    const {data} = await axios.get(`/api/backoffice/security/route`)
    this.routes = data;

    const rolesResponse = await axios.get(`/api/roles`)
    this.roles = rolesResponse.data;
  },
  methods: {
    async createRouteHandler() {
      try {
        this.$vs.loading();
        const {data} = await axios.post(`/api/backoffice/security/route`, this.createRouteForm)
        this.successNotif('¡Listo!', 'La ruta se creó correctamente');
        this.showCreatePopup = false;
        this.routes.push(data)
      } catch (e) {
        this.$vs.loading.close();
        this.errorNotif('¡Ups!', 'Hubo un error al crear la ruta');
      } finally {
        this.$vs.loading.close();
      }
    },
    async saveChangesHandler() {
      try {
        this.$vs.loading();
        await axios.put(`/api/backoffice/security/route/${this.routeSelected.id}`, this.routeSelected)
        this.successNotif('¡Listo!', 'La ruta se actualizó correctamente');
        this.showEditPopup = false;
      } catch (e) {
        this.$vs.loading.close();
        this.errorNotif('¡Ups!', 'Hubo un error al actualizar la ruta');
      } finally {
        this.$vs.loading.close();
      }
    },
    showEditPopupHandler(route) {
      this.showEditPopup = true;
      this.routeSelected = route;
    },
    confirmDeletion(route, routeIndex) {
      this.confirmationDialog(async () => {
        try {
          this.$vs.loading();
          await axios.delete(`/api/backoffice/security/route/${route.id}`)
          this.routes.splice(routeIndex, 1)
          this.successNotif('¡Listo!', 'La ruta se elimino correctamente');
        } catch (e) {
          this.$vs.loading.close();
          this.errorNotif('¡Ups!', 'Hubo un error al eliminar la ruta');
        } finally {
          this.$vs.loading.close();
        }
      },
          '¿Está seguro de eliminar esta ruta?',
          'Si borra esta ruta es posible que algún elemento del menú no funcione correctamente'
      )
    }
  }
}
</script>

<style scoped>

</style>
